export default __webpack_public_path__ + "static/teamsPerfomanceImg-02d8a2d002edb16f75a911ee6e9ef5b7.png";